import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=3db0a12b&scoped=true&"
import script from "../../models/menu-management/category.ts?vue&type=script&lang=ts&"
export * from "../../models/menu-management/category.ts?vue&type=script&lang=ts&"
import style0 from "./Category.vue?vue&type=style&index=0&id=3db0a12b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0a12b",
  null
  
)

export default component.exports